module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumbBlurLarge/VANITY-FAIR_S01.5634e81.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumbBlurLarge/VANITY-FAIR_S01.jpg
// module id = Wv3u
// module chunks = 0